import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "prehang-form" }
const _hoisted_2 = {
  key: 0,
  class: "ph-section"
}
const _hoisted_3 = { class: "ph-section-head-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "Barn Groove", -1)
const _hoisted_5 = { class: "ph-checkbox" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "barnGroove" }, "Barn Groove", -1)
const _hoisted_7 = {
  key: 0,
  class: "ph-input-group ph-two-col"
}
const _hoisted_8 = { class: "ph-section" }
const _hoisted_9 = { class: "ph-section-head-container" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", null, "Hinges", -1)
const _hoisted_11 = { class: "ph-checkbox" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "noHingePrep" }, "No Hinge Prep", -1)
const _hoisted_13 = {
  key: 0,
  class: "ph-input-group"
}
const _hoisted_14 = { class: "ph-section" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", null, "Latch and Bore", -1)
const _hoisted_16 = { class: "ph-section" }
const _hoisted_17 = {
  key: 0,
  class: "ph-section"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", null, "Double Door Options", -1)
const _hoisted_19 = { class: "ph-input-group ph-two-col" }
const _hoisted_20 = { class: "ph-section" }
const _hoisted_21 = { class: "ph-section-head-container" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h4", null, "Swing", -1)
const _hoisted_23 = { class: "ph-swing-group" }

import { PreHangSelections } from '@/services/prehang-classes/ph-selections';
    import PreHangSelect from '../inputs/PreHangSelect.vue';
    import { ref, watch, onMounted } from 'vue';
    import { MortisePrepFile, PreHangOption, SwingSelects } from '@/types/preHang';
    import SwingSelect from '../inputs/SwingSelect.vue';
    import SwingInfoModal from '@/components/modals/SwingInfoModal.vue';
    import MortiseFileInput from '../inputs/MortiseFileInput.vue';
    import CustomHingeBoreLocations from '../inputs/CustomHingeBoreLocations.vue';
    import BarnGroove from '../inputs/BarnGroove.vue';
    import HingeThickness from '../inputs/HingeThickness.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MachineForm',
  props: {
        ph: { type: PreHangSelections, required: true },
        doorHeight: { type: Number, required: false }
    },
  emits: ['updatePreHang'],
  setup(__props, { emit: emits }) {

const props = __props

    

    

    const isSwingInfoOpen = ref<boolean>(false)
    const isSingleSwingInfo = ref<boolean>(true)
    const noHingePrep = ref<boolean>(false)
    const useBarnGroove = ref<boolean>(false)

    function onSelect(option: PreHangOption, field: string) {
        props.ph?.updateSelection(option, field)
        emitPrehangUpdate()
    }

    function emitPrehangUpdate() {
        if((props.ph?.selections.machineSwingQuantities || []).length > 0) {
            emits('updatePreHang')
        }
    }

    function onUpdateSwing(swings: SwingSelects[], field: string) {
        props.ph?.updateSwingSelection(swings, field)
        emits('updatePreHang')
    }

    function openSwingInfo(isSingle = true) {
        isSingleSwingInfo.value = isSingle
        isSwingInfoOpen.value = true
    }

    function addMortiseFile(file: MortisePrepFile) {
        props.ph.addMortiseFile(file)
    }

    function removeMortiseFile(file: MortisePrepFile) {
        props.ph.removeMortiseFile(file)
    }

    watch(noHingePrep, () => {
        props.ph.CustomHingeBore.updateNoHingePrep(noHingePrep.value)
    })

    watch(useBarnGroove, () => {
        props.ph.BarnGroove.updateIsActive(useBarnGroove.value)
        emits('updatePreHang')
    })

    onMounted(() => {
        noHingePrep.value = props.ph.CustomHingeBore.noHingePrep
        useBarnGroove.value = props.ph.BarnGroove.isActive
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!props.ph.isFireOrExterior)
        ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "barnGroove",
                  class: "form-check-input",
                  "aria-label": "Barn Groove",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((useBarnGroove).value = $event))
                }, null, 512), [
                  [_vModelCheckbox, useBarnGroove.value]
                ]),
                _hoisted_6
              ])
            ]),
            (useBarnGroove.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(BarnGroove, {
                    "barn-groove": props.ph.BarnGroove,
                    onUpdatePh: _cache[1] || (_cache[1] = () => {emits('updatePreHang');})
                  }, null, 8, ["barn-groove"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!useBarnGroove.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("section", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "noHingePrep",
                    class: "form-check-input",
                    "aria-label": "No Hinge Prep",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((noHingePrep).value = $event))
                  }, null, 512), [
                    [_vModelCheckbox, noHingePrep.value]
                  ]),
                  _hoisted_12
                ])
              ]),
              (!noHingePrep.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(PreHangSelect, {
                      fieldName: "machineHingeSize",
                      label: "Hinge Size",
                      options: props.ph.activeOptions?.machineHingeSize,
                      value: props.ph.selections.machineHingeSize || null,
                      onSelect: onSelect
                    }, null, 8, ["options", "value"]),
                    _createVNode(PreHangSelect, {
                      fieldName: "machineHingeRadius",
                      label: "Hinge Radius",
                      options: props.ph.activeOptions?.machineHingeRadius,
                      value: props.ph.selections.machineHingeRadius || null,
                      onSelect: onSelect
                    }, null, 8, ["options", "value"]),
                    _createVNode(HingeThickness, {
                      value: props.ph.selections.machineHingeThickness || undefined,
                      onSelect: onSelect,
                      "has-required-error": props.ph.errors.includes('machineHingeThickness')
                    }, null, 8, ["value", "has-required-error"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("section", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", {
                class: _normalizeClass(["ph-input-group", {'ph-two-col':props.ph.selections.machineBore?.name == 'Mortise Prep'}])
              }, [
                _createVNode(PreHangSelect, {
                  fieldName: "machineBore",
                  label: "Bore",
                  options: props.ph.activeOptions?.machineBore,
                  value: props.ph.selections.machineBore || null,
                  onSelect: onSelect
                }, null, 8, ["options", "value"]),
                _createVNode(PreHangSelect, {
                  fieldName: "machineBoreBackset",
                  label: "Bore Backset",
                  "null-value": "",
                  onSelect: onSelect,
                  options: props.ph.activeOptions?.machineBoreBackset,
                  value: props.ph.selections.machineBore?.name == 'None' ? null : props.ph.selections.machineBoreBackset || null,
                  "is-disabled": props.ph.selections.machineBore?.name == 'None'
                }, null, 8, ["options", "value", "is-disabled"]),
                (props.ph.selections.machineBore?.name == 'Mortise Prep')
                  ? (_openBlock(), _createBlock(MortiseFileInput, {
                      key: 0,
                      "field-name": "mortisePrepFiles",
                      files: props.ph.mortiseFiles,
                      onUploadMortiseFile: addMortiseFile,
                      onRemoveMortiseFile: removeMortiseFile
                    }, null, 8, ["files"]))
                  : _createCommentVNode("", true),
                _createVNode(PreHangSelect, {
                  fieldName: "machineLatchPrep",
                  label: "Latch Prep",
                  "null-value": "",
                  onSelect: onSelect,
                  options: props.ph.selections.machineBore?.name == 'Mortise Prep' ? props.ph.activeOptions?.machineLatchPrep : props.ph.activeOptions?.machineLatchPrep.filter((x) => x.name != 'Mortise Prep'),
                  value: props.ph.selections.machineBore?.name == 'None' ? null : props.ph.selections.machineLatchPrep || null,
                  "is-disabled": props.ph.selections.machineBore?.name == 'None' || props.ph.selections.machineBore?.name == 'Mortise Prep'
                }, null, 8, ["options", "value", "is-disabled"])
              ], 2)
            ]),
            _createElementVNode("section", _hoisted_16, [
              _createVNode(CustomHingeBoreLocations, {
                "door-height": props.doorHeight,
                "bore-selection": props.ph.selections.machineBore?.name,
                hingeBore: props.ph.CustomHingeBore,
                "missing-errors": props.ph.errors,
                onUpdateCustomHb: emitPrehangUpdate
              }, null, 8, ["door-height", "bore-selection", "hingeBore", "missing-errors"])
            ]),
            (!props.ph.isFireOrExterior)
              ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(PreHangSelect, {
                      fieldName: "machineCatches",
                      label: "Catches",
                      options: props.ph.activeOptions?.machineCatches,
                      value: props.ph.selections.machineCatches || null,
                      onSelect: onSelect
                    }, null, 8, ["options", "value"]),
                    _createVNode(PreHangSelect, {
                      fieldName: "machineFlushBolt",
                      label: "Flush Bolt",
                      options: props.ph.activeOptions?.machineFlushBolt,
                      value: props.ph.selections.machineFlushBolt || null,
                      onSelect: onSelect
                    }, null, 8, ["options", "value"]),
                    _createVNode(PreHangSelect, {
                      fieldName: "machineTAstragal",
                      label: "T-Astragal",
                      options: props.ph.activeOptions?.machineTAstragal,
                      value: props.ph.selections.machineTAstragal || null,
                      onSelect: onSelect
                    }, null, 8, ["options", "value"]),
                    _createVNode(PreHangSelect, {
                      fieldName: "machineTAstragalStyle",
                      label: "T-Astragal Style",
                      options: (props.ph.selections.machineTAstragal?.name == 'None') ? props.ph.activeOptions?.machineTAstragalStyle : props.ph.activeOptions?.machineTAstragalStyle.filter((x)=> x.name!='None'),
                      value: props.ph.selections.machineTAstragalStyle || null,
                      "is-disabled": props.ph.selections.machineTAstragal?.name == 'None',
                      onSelect: onSelect
                    }, null, 8, ["options", "value", "is-disabled"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (openSwingInfo()))
                }, "View Door Swing Images")
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(SwingSelect, {
                  "field-name": "machineSwingQuantities",
                  selections: props.ph.selections.machineSwingQuantities || [],
                  options: props.ph?.activeOptions?.machineOnlySwing,
                  onUpdateSwing: onUpdateSwing
                }, null, 8, ["selections", "options"])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(SwingInfoModal, {
      modelValue: isSwingInfoOpen.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isSwingInfoOpen).value = $event)),
      "is-single-swing-info": isSingleSwingInfo.value,
      "is-fire-or-exterior": props.ph.isFireOrExterior
    }, null, 8, ["modelValue", "is-single-swing-info", "is-fire-or-exterior"])
  ], 64))
}
}

})